<div class="modal-header">
  <h3 class="mb-5" translate>account_changepassword</h3>
  <button
    type="button"
    class="btn-close shadow-none"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <div class="t-1">
    <div class="toastr-relative toastr-sm toastr-no-shadow my-4 custom-alert" toastContainer></div>
  </div>
  <form [formGroup]="passwordForm">
    <div class="page__form-wrap">
      <div class="form-group row" *ngIf="typeResetPassword === 'web'">
        <label for="current-password" class="col-sm-4" translate>change_password_old</label>
        <div class="col-sm-8 password-line">
          <input
            [type]="showPasswordOld ? 'text' : 'password'"
            class="form-control"
            id="current-password"
            formControlName="currentPassword"
            wsbAppControlValidator
            [fc]="passwordForm.get('currentPassword')"
          />
          <wsb-atlas-button
            variant="icon"
            [icon]="faPasswordOldIconShow"
            roundButton=""
            size="sm"
            noHover="true"
            (click)="showHidePassWordOld()"
          >
          </wsb-atlas-button>
          <wsb-validation-error-msg [fc]="passwordForm.get('currentPassword')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="new-password" class="col-sm-4" translate>change_password_new</label>
        <div class="col-sm-8 password-line">
          <input
            [type]="showPasswordNew ? 'text' : 'password'"
            class="form-control"
            id="new-password"
            formControlName="newPassword"
            wsbAppControlValidator
            [fc]="passwordForm.get('newPassword')"
          />
          <wsb-atlas-button
            variant="icon"
            [icon]="faPasswordNewIconShow"
            roundButton=""
            size="sm"
            noHover="true"
            (click)="showHidePassWordNew()"
          >
          </wsb-atlas-button>
          <wsb-validation-error-msg [fc]="passwordForm.get('newPassword')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="confirm-new-password" class="col-sm-4" translate>change_password_repeat</label>
        <div class="col-sm-8 password-line">
          <input
            [type]="showPasswordRepeat ? 'text' : 'password'"
            class="form-control"
            id="confirm-new-password"
            formControlName="confirmNewPassword"
            wsbAppControlValidator
            [fc]="passwordForm.get('confirmNewPassword')"
          />
          <wsb-atlas-button
            variant="icon"
            account
            [icon]="faPasswordRepeatIconShow"
            roundButton=""
            size="sm"
            noHover="true"
            (click)="showHidePassWordRepeat()"
          >
          </wsb-atlas-button>
          <wsb-validation-error-msg [fc]="passwordForm.get('confirmNewPassword')"></wsb-validation-error-msg>
        </div>
      </div>
    </div>
  </form>
</div>
<!-- <div class="modal-footer">
  <div class="actions-bar__container  actions-bar__container--actions">
    <button class="btn  btn-primary  btn-sm" [disabled]="passwordForm.pristine || passwordForm.invalid" (click)="doSubmit()" translate>
      common_save
    </button>
    <button *ngIf="passwordForm.dirty" type="button" class="btn btn-link btn-sm ms-2" (click)="cancel()" translate>common_cancel</button>
  </div>
</div> -->

<div class="modal-footer">
  <div #modalFooter><ng-content select="[footer]"></ng-content></div>
  <div *ngIf="!modalFooter.innerHTML.trim()">
    <wsb-atlas-button
      *ngIf="passwordForm.dirty"
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="cancel()"
      label="common_cancel"
    ></wsb-atlas-button>
    <wsb-atlas-button
      variant="primary"
      [disabled]="passwordForm.pristine || passwordForm.invalid"
      (btnClick)="doSubmit()"
      label="common_save"
    ></wsb-atlas-button>
  </div>
</div>

<!--

<wsb-modal
  class="custom-modal-width"
  cancelButtonEnable="true"
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  title="{{ 'LANDING PAGE MODAL' | translate }}"
  primaryButtonText="common_send"
>
  <div body>
    <div class="form-group" style="display: flex; align-items: center;">

      <form [formGroup]="passwordForm">
        <div class="row">
          <div class="col" toastContainer></div>
        </div>
        <div class="page__form-wrap">
          <div class="form-group row">
            <label for="current-password" class="col-sm-4" translate>change_password_old</label>
            <div class="col-sm-8 password-line">
              <input
                [type]="showPasswordOld ? 'text' : 'password'"
                class="form-control"
                id="current-password"
                formControlName="currentPassword"
                wsbAppControlValidator
                [fc]="passwordForm.get('currentPassword')"
              />
              <wsb-atlas-button
                variant="icon"
                [icon]="faPasswordOldIconShow"
                roundButton=""
                size="sm"
                noHover="true"
                (click)="showHidePassWordOld()"
              >
              </wsb-atlas-button>
              <wsb-validation-error-msg [fc]="passwordForm.get('currentPassword')"></wsb-validation-error-msg>
            </div>
          </div>
          <div class="form-group row">
            <label for="new-password" class="col-sm-4" translate>change_password_new</label>
            <div class="col-sm-8 password-line">
              <input
                [type]="showPasswordNew ? 'text' : 'password'"
                class="form-control"
                id="new-password"
                formControlName="newPassword"
                wsbAppControlValidator
                [fc]="passwordForm.get('newPassword')"
              />
              <wsb-atlas-button
                variant="icon"
                [icon]="faPasswordNewIconShow"
                roundButton=""
                size="sm"
                noHover="true"
                (click)="showHidePassWordNew()"
              >
              </wsb-atlas-button>
              <wsb-validation-error-msg [fc]="passwordForm.get('newPassword')"></wsb-validation-error-msg>
            </div>
          </div>
          <div class="form-group row">
            <label for="confirm-new-password" class="col-sm-4" translate>change_password_repeat</label>
            <div class="col-sm-8 password-line">
              <input
                [type]="showPasswordRepeat ? 'text' : 'password'"
                class="form-control"
                id="confirm-new-password"
                formControlName="confirmNewPassword"
                wsbAppControlValidator
                [fc]="passwordForm.get('confirmNewPassword')"
              />
              <wsb-atlas-button
                variant="icon"
                [icon]="faPasswordRepeatIconShow"
                roundButton=""
                size="sm"
                noHover="true"
                (click)="showHidePassWordRepeat()"
              >
              </wsb-atlas-button>
              <wsb-validation-error-msg [fc]="passwordForm.get('confirmNewPassword')"></wsb-validation-error-msg>
            </div>
          </div>
        </div>
      </form>


    </div>
  </div>
</wsb-modal> -->
